module.exports = __webpack_public_path__ + "static/media/hartwall-step-arrow.02a22153.svg";